import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { guaranteeItems } from "../../data/content";
import { SectionCta } from "../SectionCta";
export function Guarantee() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-179" data-mp="24moqj74jg2mf">
      <div className="mx-auto max-w-3xl rounded-3xl border-2 border-gold bg-cream p-6 text-center md:p-10" data-id="element-180" data-mp="24l3sv8mxg3kc">
        <div className="mx-auto grid h-24 w-24 place-items-center rounded-full bg-navy" data-id="element-181" data-mp="29frlnjoyrk4q">
          <ShieldCheckIcon className="h-12 w-12 text-gold" aria-hidden="true" data-id="element-182" data-mp="2ef44ltcps721" />
        </div>
        <p className="mt-5 text-xs font-extrabold uppercase tracking-[0.18em] text-gold-dark" data-id="element-183" data-mp="2je7b7i8celc4">7-day guarantee</p>
        <h2 className="mt-2 font-serif text-[30px] font-black leading-[1.1] text-navy md:text-4xl" data-id="element-184" data-mp="2o9cwqfxu1xzo">
          Explore The Abdominoplasty Master System™ <em className="italic text-gold-dark" data-id="element-185" data-mp="txy15ii554c0">Risk-Free</em>
        </h2>
        <p className="mt-4 text-[17px] leading-relaxed text-navy/75" data-id="element-186" data-mp="xyhzgpegadzq">
          I want you to be able to open the system, explore the framework and decide for yourself whether it adds value
          to your professional learning.
        </p>
        <p className="mt-5 font-bold text-navy" data-id="element-187" data-mp="3ntybl0nspqhn">For 7 days, you can:</p>
        <ul className="mx-auto mt-3 grid max-w-xl gap-2 text-left sm:grid-cols-2" data-id="element-188" data-mp="3iuu0u5l83kp7">
          {guaranteeItems.map(g => <li key={g} className="flex items-start gap-2 text-[15px] text-navy" data-id="element-189" data-mp="3dxv55ilwv5ow">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-190" data-mp="fdvc3i6u784e" />
              {g}
            </li>)}
        </ul>
        <p className="mt-6 text-[16px] leading-relaxed text-navy/75" data-id="element-191" data-mp="adz7bgqbfcns">
          If you decide the system isn't useful for your professional education, contact us within the guarantee period
          according to the purchase terms and request a refund.
        </p>
        <p className="mt-2 font-serif text-xl font-black text-navy" data-id="element-192" data-mp="2q7r7rszbg26c">No complicated process.</p>

        <SectionCta label="Try the system risk-free for 7 days" data-id="element-193" data-mp="2l73gr7b37lc4" />
      </div>
    </section>;
}